import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
// import Client from '../views/client-case.vue'
// import Company from '../views/company-introduction.vue'
// import Product from '../views/product-capacity.vue'

Vue.use(VueRouter)

  const routes = [
  // {
  //   path: '/',
  //   name: 'index',
  //   component: index,
  //   redirect: '/company', //默认子路由
  //   children:[
  //     {
  //     path: '/company',
  //     component: Company
  //     },
  //     {
  //     path: '/product',
  //     component: Product
  //     },
  //     {
  //     path: '/client',
  //     component: Client
  //     }
  //   ]
  // }
  {
      path: '/',
      name: 'index',
      component: index
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
